import { render, staticRenderFns } from "./ProductReviews.vue?vue&type=template&id=267ff2d5"
import script from "./ProductReviews.vue?vue&type=script&lang=js"
export * from "./ProductReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports